module.exports = __webpack_public_path__ + "static/media/flooring.019d0b51.svg";